import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import adminAuthApi from '../api/adminAuthApi';
import adminSchemaApi from '../api/adminSchemaApi';
import AdminHeader from './AdminHeader';
import '../styles/admin-theme.css';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [schemas, setSchemas] = useState([]);
  const menuTabs = [
    { id: 'schemas', label: 'Schemas', url: '/admin/schemas' },
    { id: 'pricebooks', label: 'Pricebooks', url: '/admin/pricebooks' },
    { id: 'license-types', label: 'License Types', url: '/admin/license-types' },
    { id: 'plans', label: 'Plans', url: '/admin/plans' },
  ];
  const [selectedSchema, setSelectedSchema] = useState(
    localStorage.getItem('adminSchema') || ''
  );

  const adminToken =
    typeof window !== 'undefined' ? localStorage.getItem('adminToken') : null;

  useEffect(() => {
    if (!adminToken) {
      navigate('/admin/login', { replace: true });
    }
  }, [navigate, adminToken]);

  useEffect(() => {
    const loadSchemas = async () => {
      try {
        const companies = await adminSchemaApi.fetchSchemas();
        const normalized = companies
          .filter(company => company?.tenantcode)
          .map(company => ({
            value: company.tenantcode,
            label: company.name
              ? `${company.name} (${company.tenantcode})`
              : company.tenantcode,
          }));
        setSchemas(normalized);
      } catch (error) {
        console.error('Admin schema list error:', error);
        setSchemas([]);
      }
    };

    loadSchemas();
  }, []);

  const handleLogout = () => {
    adminAuthApi.logout();
    navigate('/admin/login');
  };

  const handleSchemaChange = value => {
    setSelectedSchema(value);
    localStorage.setItem('adminSchema', value);
  };

  if (!adminToken) {
    return (
      <div
        className='admin-theme d-flex align-items-center justify-content-center'
        style={{ minHeight: '50vh' }}
      >
        <span className='text-muted'>Redirecting to login…</span>
      </div>
    );
  }

  return (
    <div className='admin-dashboard'>
      <AdminHeader
        schemas={schemas}
        selectedSchema={selectedSchema}
        onSchemaChange={handleSchemaChange}
        onLogout={handleLogout}
        menuTabs={menuTabs}
      />
      <Container className='p-4'>
        <Outlet />
      </Container>
    </div>
  );
};

export default AdminDashboard;
